import { View } from "binder"
import { DistrictSelector } from "src/erp/enterpriseAdministration/districts/districtManipulation/districtSelector";
import { WarehouseEditorViewModel } from "./warehouseEditor-viewModel"

export class WarehouseEditorView extends View<WarehouseEditorViewModel>{
    GetViewUniqueId(): string {
        return "V-DBFBEB37-6977-436A-8B88-03D82EFCF9FA"
    }
    loadHtml(): string {
        let element = require('./warehouseEditor.html').default;
        let style = require('./warehouseEditor.less');
        return element;
    }
    constructor() {
       super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;

    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set districtSelector(v: DistrictSelector) { this._districtSelector = v; } public get districtSelector(): DistrictSelector { return this._districtSelector;} private _districtSelector: DistrictSelector;

    back(){
        this.dataContext.back();
    }

    save(){
        this.dataContext.save();
    }
}
